import Vue from "vue";
import Vuex from "vuex";
import parameterStripe from "./modues/parameterStripe.js";
import map from "./modues/map.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: { parameterStripe, map },
});
